import { Injectable, NgZone } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { UserNotification } from '../interfaces/userNotification';
import * as firebase from 'firebase/compat/app';
import { NotificationService } from './notification.service';
import { Notification } from '../interfaces/notification';
import { StorageTypeKey } from '../enums/StorageTypeKey';

@Injectable()
export class FirebaseService {
  observables = new Map<string, BehaviorSubject<UserNotification>>();

  getObservable(topic: string): BehaviorSubject<UserNotification> {
    return this.observables.get(topic);
  }

  subscribe(topic: string, observer: any): BehaviorSubject<UserNotification> {
    let behaviorSubject = this.observables.get(topic);
    if (!behaviorSubject) {
      behaviorSubject = new BehaviorSubject<UserNotification>(null);
    }
    behaviorSubject.subscribe(observer);
    this.observables.set(topic, behaviorSubject);
    return this.observables.get(topic);
  }

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private notificationService: NotificationService,
    private zone: NgZone,
  ) {}

  subscribeToFirebase() {
    this.angularFireMessaging.messages.subscribe((message) => {
      this.onMessage(message);
    });
    this.angularFireMessaging.tokenChanges.subscribe((token) => {
      this.setFirebaseToken(token);
    });
    this.subscribeToBroadcastChannel();
  }

  subscribeToBroadcastChannel() {
    if (firebase.default.messaging.isSupported()) {
      const channel = new BroadcastChannel('sw-messages');
      channel.addEventListener('message', (message) => this.onMessage(message.data));
      console.log('firebase service init');
    } else {
      console.log('BroadcastChannel not supported');
    }
  }

  public setFirebaseToken(token: string) {
    if (!token) {
      throw new Error(`Firebase Token is Required`);
    }
    localStorage.setItem(StorageTypeKey.FIREBASE_TOKEN, token);
  }

  async getFirebaseToken(): Promise<string> {
    let token = localStorage.getItem(StorageTypeKey.FIREBASE_TOKEN);
    if (!token) {
      token = await this.requestPermission();
      this.setFirebaseToken(token);
    }
    return token;
  }

  onMessage(message: any) {
    const notification: UserNotification | Notification = JSON.parse(message.data?.notification);
    console.log('in firebase we got a message', notification);
    this.notificationService.addNewNotification(notification);
    this.zone.run(() => {
      this.getObservable(notification.topic)?.next(notification as UserNotification);
      this.getObservable(notification.topic)?.next(null);
    });
  }

  async requestPermission(): Promise<string> {
    await this.angularFireMessaging.requestPermission.toPromise();
    const token = await this.angularFireMessaging.getToken.toPromise();
    this.setFirebaseToken(token);
    this.subscribeToFirebase();
    return token;
  }
}
